module.exports = __webpack_public_path__ + "323fb60e5395414671bf171ae8bbf5d1.pdf";